import { FetchApiResponse } from "redux/types";

export enum NpaReportReduxTypes {
    NPA_REPORT="@@auth/NPA_REPORT",
    NPA_REPORT_SUCCESS="@@auth/NPA_REPORT_SUCCESS",
    NPA_REPORT_ERROR="@@auth/NPA_REPORT_ERROR"
}

export type NpaReportActionDispatch = {
    type : | NpaReportReduxTypes.NPA_REPORT;
    payload: any;
}

export type NpaReportReducerDispatch = {
    type : | NpaReportReduxTypes.NPA_REPORT
    | NpaReportReduxTypes.NPA_REPORT_SUCCESS
    | NpaReportReduxTypes.NPA_REPORT_ERROR

    payload : {
        data ?: FetchApiResponse<NpaReport>
        error ?: string
    }
}

export type NpaReport={
id : string,
financierId: string,
userId: string,
type: string,
status: number,
updatedOn: string;
createdOn: string;
}

export type CreateNpaReportRequest = {
    payload:{},
    type : string
}

export type CreateNpaReportReduxState = {
    loading ?: boolean
    data ?: {},
    error ?: string | null;
}